import { useQueryClient } from 'react-query';

export function useCycleRefresh(cycleId: string) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries(['review-cycle', cycleId]);
    queryClient.invalidateQueries(['review', cycleId]);
  };
}
